import superagent from 'superagent';

const CONFIG_URLS = {
    PROD: {
        GET_ARC: "https://get-pdf-url-vvqogwqsfa-no.a.run.app",
        CALL_TWILIO: "https://call-twilio-vvqogwqsfa-no.a.run.app",
        SAVE_CERT_KEY: "https://save-cert-key-vvqogwqsfa-no.a.run.app",
        GET_PDF: "https://get-pdf-vvqogwqsfa-no.a.run.app",
        SEND_MFA_EMAIL: "https://email-mfa-vvqogwqsfa-no.a.run.app",
        GET_USER_DOCS: "https://get-user-documents-vvqogwqsfa-no.a.run.app",
        PREPARE_AUTOFIRMA_BATCH: "https://europe-southwest1-delagros-firmados.cloudfunctions.net/prepare_autofirma_batch",
        COMPLETE_AUTOFIRMA_BATCH: "https://europe-southwest1-delagros-firmados.cloudfunctions.net/complete_autofirma_batch"
    },
    TEST: {
        GET_ARC: "https://get-pdf-url-tzqgs4wzia-no.a.run.app",
        CALL_TWILIO: "https://call-twilio-tzqgs4wzia-no.a.run.app",
        SAVE_CERT_KEY: "https://save-cert-key-tzqgs4wzia-no.a.run.app",
        GET_PDF: "https://get-pdf-tzqgs4wzia-no.a.run.app",
        SEND_MFA_EMAIL: "https://email-mfa-tzqgs4wzia-no.a.run.app",
        GET_USER_DOCS: "https://get-user-documents-tzqgs4wzia-no.a.run.app",
        PREPARE_AUTOFIRMA_BATCH: "https://europe-southwest1-firmados-pruebas.cloudfunctions.net/prepare_autofirma_batch",
        COMPLETE_AUTOFIRMA_BATCH: "https://europe-southwest1-firmados-pruebas.cloudfunctions.net/complete_autofirma_batch"
    }
};

const getUrl = (key: keyof typeof CONFIG_URLS.PROD): string => {
    const hostname = window.location.hostname;
    if (hostname.includes("firma-pruebas")) {
        console.log(`Usando entorno TEST para: ${key}`);
        return CONFIG_URLS.TEST[key];
    }
    // Si no, usa PRODUCCIÓN
    return CONFIG_URLS.PROD[key];
};

interface Respuesta<T> {
    error: boolean; // True if there was an error
    data: T;        // The payload on success
    msg: string;    // Error message on failure
}
/**
 * Solicita la busqueda del archivo
 * 
 * @param {any} body_request - Recibe un objeto con los datos del usuario.
 * @return {Promise} - Retorna una promesa al ser completada retorna un objeto Respuesta.
 */
export const solicitarArchivo = async(body_request: any, idToken: string): Promise<Respuesta<any>> => {
    try {
        const respuesta = await superagent.post(getUrl("GET_ARC"))
            .send(body_request)
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${idToken}`);

        const body = respuesta.body || {};
        return {
            error: false,
            msg: "",
            data: {
                url: body?.url_documento ?? "",
                url_firmado: body?.url_documento_firmado ?? "",
                url_auditoria: body?.url_registro_auditoria ?? "",
                nombre_documento: body?.nombre_documento ?? "",
                estado: body?.estado ?? "",
                telefono: body?.telefono ?? "",
                email: body?.email ?? "",
                enviar_email: body?.enviar_email ?? ""
            }
        };
    } catch (error: any) {
        const errorMessage = error.response?.body?.data || error.response?.body?.message || error.message || "Error desconocido";
        return {
            error: true,
            data: {},
            msg: errorMessage,
        };
    }
};

/**
 * Interacción con Twilio
 * 
 * @param {any} body_request - Recibe un objeto con los datos del usuario.
 * @return {Promise} - Retorna una promesa al ser completada retorna un objeto Respuesta.
 */
export const callTwilio = async(body_request: any, idToken: string): Promise<Respuesta<any>> => {
    try {
        const respuesta = await superagent.post(getUrl("CALL_TWILIO"))
            .send(body_request)
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${idToken}`);

        return { error: false, data: respuesta.body || {}, msg: "" };
    } catch (error: any) {
        const errorMessage = error.response?.body?.message || error.message || "Error en la solicitud a Twilio";
        return { error: true, data: {}, msg: errorMessage };
    }
};

/**
 * Interacción con SecretManager
 * 
 * @param {any} body_request - Recibe un objeto con los datos del usuario.
 * @return {Promise} - Retorna una promesa al ser completada retorna un objeto Respuesta.
 */
export const save_cert_key = async(body_request: any, idToken: string): Promise<Respuesta<any>> => {
    try {
        const respuesta = await superagent.post(getUrl("SAVE_CERT_KEY"))
            .send(body_request)
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${idToken}`);

        return { error: false, data: respuesta.body || {}, msg: "" };

    } catch (error: any) {
        const errorMessage = error.response?.body?.message || error.message || "Error al guardar la clave del certificado";
        return { error: true, data: {}, msg: errorMessage };
    }
};

/**
 * Envío de email
 * 
 * @param {any} body_request - Recibe un objeto con los datos del usuario.
 * @return {Promise} - Retorna una promesa al ser completada retorna un objeto Respuesta.
 */
export const mfaEmail = async(body_request: any, idToken: string): Promise<Respuesta<any>> => {
    try {
        const respuesta = await superagent.post(getUrl("SEND_MFA_EMAIL"))
            .send(body_request)
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${idToken}`);

        return { error: false, data: respuesta.body || {}, msg: "" };

    } catch (error: any) {
        const errorMessage = error.response?.body?.message || error.message || "Error en la solicitud de MFA por email";
        return { error: true, data: {}, msg: errorMessage };
    }
};


/**
 * Interacción con Firebase Cloud Function para obtener un PDF
 * 
 * @param {any} body_request - Recibe un objeto con la URL del PDF.
 * @param {string} idToken - Token de autenticación de Firebase.
 * @return {Promise} - Retorna una promesa con el resultado de la llamada.
 */
export const getPdfFromFirebase = async (body_request: any, idToken: string): Promise<Respuesta<{ pdfUrl: string }>> => {
    try {
        const respuesta = await superagent.post(getUrl("GET_PDF"))
            .send(body_request)
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${idToken}`)
            .responseType('blob');

        const pdfBlob = respuesta.body as Blob;
        const pdfUrl = URL.createObjectURL(pdfBlob);
        return { error: false, data: { pdfUrl }, msg: "" };

    } catch (error: any) {
        const errorMessage = error.response?.body?.message || error.message || "Error al obtener el PDF desde Firebase";
        return { error: true, data: { pdfUrl: '' }, msg: errorMessage };
    }
};

/**
 * Obtiene los documentos del usuario logueado (Dashboard)
 */
export const obtenerDocumentosUsuario = async(estado: string, idToken: string): Promise<Respuesta<any[]>> => {
    try {
        const respuesta = await superagent
            .post(getUrl("GET_USER_DOCS"))
            .send({ estado: estado })
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${idToken}`);
        
        return { error: false, data: respuesta.body.data || [], msg: "" };

    } catch (error: any) {
        const errorMessage = error.response?.body?.message || error.message || "Error al obtener los documentos";
        return { error: true, data: [], msg: errorMessage };
    }
};

/**
 * Llama al backend para preparar los datos necesarios para la firma en lote.
 */
export const prepareAutofirmaBatch = async (docIds: string[], idToken?: string | null, esEnlace: boolean = false): Promise<any> => {
    try {
        // 1. Preparamos la petición base (común para ambos)
        let peticion = superagent
            .post(getUrl("PREPARE_AUTOFIRMA_BATCH"))
            .send({ doc_ids: docIds, es_enlace: esEnlace })
            .set('Content-Type', 'application/json;charset=utf-8');

        // 2. Si HAY token (usuario registrado), le inyectamos la cabecera de seguridad
        if (idToken) {
            peticion = peticion.set('Authorization', `Bearer ${idToken}`);
        }

        // 3. Ejecutamos la petición
        const respuesta = await peticion;

        // Si superagent no lo convierte automáticamente, lo hacemos nosotros con .text
        return respuesta.body ? respuesta.body : JSON.parse(respuesta.text);
    } catch (error: any) {
        // Mejoramos también la captura del mensaje de error
        const msg = error.response?.body?.message || error.response?.text || "Error al preparar los documentos en el servidor.";
        return { error: true, data: null, msg };
    }
};

/**
 * Envía las firmas generadas por AutoFirma al backend para completar el proceso.
 */
export const completeAutofirmaBatch = async (transactionId: string, signatures: any[], idToken?: string | null, esEnlace: boolean = false): Promise<any> => {
    try {
        let peticion = superagent
            .post(getUrl("COMPLETE_AUTOFIRMA_BATCH"))
            .send({
                transaction_id: transactionId,
                signatures: signatures,
                es_enlace: esEnlace
            })
            .set('Content-Type', 'application/json;charset=utf-8');

        // Solo inyectamos el token si el usuario está logueado
        if (idToken) {
            peticion = peticion.set('Authorization', `Bearer ${idToken}`);
        }

        const respuesta = await peticion;
        return respuesta.body ? respuesta.body : JSON.parse(respuesta.text);
    } catch (error: any) {
        const msg = error.response?.body?.message || error.response?.text || "Error al completar la firma en el servidor.";
        return { error: true, data: null, msg };
    }
};

// Declaración para que TypeScript reconozca el objeto AutoFirma global
// Declaración para que TypeScript reconozca el objeto AutoFirma global
declare global {
    interface Window {
        AutoScript: {
            createBatch: (algorithm: string, format: string, subOperation: string, extraParams: string) => void;
            addDocumentToBatch: (id: string, data: string, format: string | null, suboperation: string | null, extraParams: string | null) => void;
            setLocalBatchProcess: (isLocal: boolean) => void;
            signBatchProcess: (stopOnError: boolean, preUrl: string | null, postUrl: string | null, extraParams: string, successCallback: (results: any, certB64?: any) => void, errorCallback: (type: string, message: string) => void) => void;
        };
    }
}

/**
 * Helper to wait for the AutoScript object to be defined on the window.
 * This is necessary because autoscript.js might load asynchronously.
 * @param timeout - Time in ms to wait before failing.
 */
const waitForAutoScript = (timeout = 5000): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (typeof window.AutoScript !== 'undefined') {
            return resolve();
        }
        const startTime = Date.now();
        const interval = setInterval(() => {
            if (typeof window.AutoScript !== 'undefined') {
                clearInterval(interval);
                return resolve();
            }
            if (Date.now() - startTime > timeout) {
                clearInterval(interval);
                return reject(new Error("Timeout esperando al componente de firma (AutoScript)."));
            }
        }, 100);
    });
};

/**
 * Orquesta el proceso completo de firma por lotes con AutoFirma.
 * @param documentIds - Un array con los IDs de los documentos a firmar.
 * @param idToken - Token de autenticación de Firebase.
 * @param showLoader - Función para mostrar el loader.
 * @param hideLoader - Función para ocultar el loader.
 * @param showAlert - Función para mostrar alertas.
 */
export const orchestrateAutofirmaBatch = async (
    documentIds: string[],
    idToken: string | null,
    esEnlace: boolean,
    showLoader: (msg: string) => void,
    hideLoader: () => void,
    showAlert: (msg: string) => void
): Promise<any> => {
    if (documentIds.length === 0 || documentIds.length > 10) { // Límite de 10 documentos
        const errorMsg = "Debe seleccionar entre 1 y 10 documentos.";
        showAlert(errorMsg);
        return Promise.reject(new Error(errorMsg));
    }

    return new Promise(async (resolve, reject) => {
        showLoader("Iniciando comunicación con AutoFirma...");

        let isAutoScriptReady = false;
        try {
            // Intento 1: Esperar un poco por si ya está abierto.
            await waitForAutoScript(2000);
            isAutoScriptReady = true;
        } catch (e) {
            // Si falla, intentamos lanzarlo y esperamos más tiempo.
            showLoader("AutoFirma no detectado. Intentando iniciar...");
            window.location.href = 'afirma://';
            try {
                await waitForAutoScript(10000); // Damos 10s para que la app inicie
                isAutoScriptReady = true;
            } catch (e2) {
                isAutoScriptReady = false;
            }
        }

        if (!isAutoScriptReady) {
            hideLoader();
            const finalErrorMsg = `
                <div style="text-align: left; line-height: 1.5;">
                    <p style="font-weight: bold; color: #d32f2f; font-size: 1.1em;">
                        ⚠️ No se ha podido conectar con AutoFirma
                    </p>
                    
                    <p><strong>1. Inicie la aplicación:</strong><br>
                    Si no se ha abierto automáticamente, por favor busque <b>AutoFirma</b> en su ordenador e iníciela manualmente.</p>
                    
                    <p><strong>2. ¿Sigue sin funcionar?</strong><br>
                    Su navegador puede estar solicitando un permiso de seguridad adicional:</p>
                    
                    <ul style="padding-left: 20px;">
                        <li>Haga <a href="https://localhost:64198/afirma" target="_blank" style="color: #007bff; font-weight: bold;">clic aquí para dar permiso</a>.</li>
                        <li>Si aparece un aviso de "Conexión no privada", pulse en <b>"Configuración avanzada"</b> y luego en <b>"Acceder/Continuar"</b>.</li>
                        <li>Cierre esa pestaña y pulse <b>Firmar</b> de nuevo en esta página.</li>
                    </ul>
                </div>`;
            
            /*`No se pudo comunicar con AutoFirma.

**Paso 1: Iniciar la aplicación**
Se ha intentado abrir la aplicación AutoFirma. Si no se abre sola, por favor, iníciela manualmente.

**Paso 2: Solucionar bloqueo (si el problema persiste)**
Si la aplicación ya está abierta, el navegador puede estar bloqueando la comunicación. Para solucionarlo (solo necesita hacerlo una vez):
1. Abra una nueva pestaña y vaya a: https://localhost:64198/afirma
2. Verá una advertencia de 'La conexión no es privada'. Haga clic en 'Configuración avanzada' y luego en 'Acceder a localhost (sitio no seguro)'.
3. Vuelva a esta página e intente firmar de nuevo.`;*/
            showAlert(finalErrorMsg);
            return reject(new Error(finalErrorMsg));
        }

        // Si llegamos aquí, AutoScript está listo.
        // No es necesario 'checkService', procedemos directamente a la preparación.
        (async () => {
            const msgLoader = documentIds.length === 1 
                ? "Preparando el documento para la firma..." 
                : `Preparando ${documentIds.length} documentos para la firma...`;
            showLoader(msgLoader);
            try {
                const prepResponse = await prepareAutofirmaBatch(documentIds, idToken);
                if (!prepResponse || prepResponse.error || !prepResponse.data) {
                    throw new Error(prepResponse?.msg || "Error en el servidor al preparar los documentos.");
                }
                
                // Adaptamos el array para asegurar que AutoFirma sepa que es un PDF
                const { transaction_id, requests } = prepResponse.data;

                // 1. Iniciamos el lote global con formato PAdES (PDF)
                const parametrosVisuales = "signatureField=SigUsuario\nlayer2Text=Firmado por $$SUBJECTCN$$";
                window.AutoScript.createBatch("SHA256withRSA", "PAdES", "sign", parametrosVisuales);

                // 2. Añadimos los documentos uno a uno
                requests.forEach((req: any) => {
                    // Ahora pasamos null en todo para que herede la configuración global estricta
                    window.AutoScript.addDocumentToBatch(req.doc_id, req.data_to_sign, null, null, null);
                });

                // 3. Indicamos que es una firma 100% local (sin llamadas intermedias a servidor de @firma)
                window.AutoScript.setLocalBatchProcess(true);

                showLoader("Esperando firma en AutoFirma...");

                // 4. Ejecutamos el lote
                window.AutoScript.signBatchProcess(
                    false, // stopOnError
                    null,  // presignUrl (null para local)
                    null,  // postsignUrl (null para local)
                    "",    // extraParams
                    async (autofirmaResults: any, certB64: any) => {
                        showLoader("Enviando firma al servidor...");
                        //console.log(">> RAW AutoFirma Results:", autofirmaResults);
                        
                        let parsedResults: any[] = [];

                        try {
                            if (typeof autofirmaResults === 'string') {
                                // A. Si es un string y parece XML
                                if (autofirmaResults.trim().startsWith("<")) {
                                    const parser = new DOMParser();
                                    const xmlDoc = parser.parseFromString(autofirmaResults, "text/xml");
                                    const singles = xmlDoc.getElementsByTagName("singlesign") || xmlDoc.getElementsByTagName("sign");
                                    
                                    parsedResults = Array.from(singles).map((node: any) => ({
                                        id: node.getAttribute("Id") || node.getAttribute("id"),
                                        result: node.getElementsByTagName("signature")[0]?.textContent || node.getElementsByTagName("result")[0]?.textContent
                                    }));
                                } 
                                // B. Si es un string pero es JSON
                                else {
                                    const parsed = JSON.parse(autofirmaResults);
                                    const singles = parsed.signs || parsed.singlesigns || parsed.singlesign || parsed;
                                    const singlesArray = Array.isArray(singles) ? singles : [singles];
                                    
                                    parsedResults = singlesArray.map((s: any) => ({
                                        id: s.id || s.Id,
                                        result: s.signature || s.result || s.resultValue || s.sign
                                    }));
                                }
                            } 
                            // C. Si ya viene como un Objeto JSON puro (¡ESTE ES TU CASO!)
                            else if (autofirmaResults && typeof autofirmaResults === 'object') {
                                // Buscamos específicamente el array 'signs' que hemos visto en tu log
                                const singles = autofirmaResults.signs || autofirmaResults.singlesigns || autofirmaResults.singlesign || autofirmaResults;
                                const singlesArray = Array.isArray(singles) ? singles : [singles];
                                
                                parsedResults = singlesArray.map((s: any) => ({
                                    id: s.id || s.Id,
                                    // LA CLAVE: El Base64 viene en 'signature'. Lo mapeamos a 'result' que es lo que espera Python.
                                    result: s.signature || s.result || s.resultValue || s.sign
                                }));
                            }
                        } catch (e) {
                            console.error("Error interpretando la respuesta de AutoFirma:", e);
                        }

                        //console.log(">> Firmas extraídas para Python:", parsedResults);

                        // Si el parser no pudo sacar nada, abortamos antes de llamar a Python
                        if (parsedResults.length === 0 || !parsedResults[0].result || parsedResults[0].result === "DONE_AND_SAVED") {
                            hideLoader();
                            reject(new Error("No se pudo extraer el Base64 de la firma. Revisa la consola del navegador."));
                            return;
                        }

                        // Enviamos los resultados a Python
                        try {
                            const finalResponse = await completeAutofirmaBatch(transaction_id, parsedResults, idToken);
                            hideLoader();
                            resolve(finalResponse);
                        } catch(e) {
                            hideLoader();
                            reject(e);
                        }
                    },
                    (type, message) => {
                        hideLoader();
                        reject(new Error(`Error de AutoFirma: [${type}] ${message}`));
                    }
                );
            } catch (error: any) {
                hideLoader();
                reject(error);
            }
        })();
    });
};
